import Footer from "../Utils/Footer";
import LocationUtils from "../Utils/LocationUtils";
import Navbar from "../Utils/Navbar";
import Offering from "../Utils/Offering";

const Location = () => {
  return (
    <>
      <Navbar />
      <LocationUtils />
      <Offering />
      <Footer />
    </>
  );
};

export default Location;
